module.exports = __webpack_public_path__ + "static/media/MENSA.3336ca4c.png";